import * as ko from "knockout";
import Bao from "./../services/bao-service";
import rekTemplate from "./bao-tree.html";
// bao migrate - module not found: import "services/bao-template-engine";
import "./drag";
import "./drop";
Bao.Templates.baoTree = rekTemplate;
ko.bindingHandlers.baoTree = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        $(element).addClass("baotree");
        var baoTreeVM = function () {
            this.ToggleNode = function (node) {
                node.Expanded(!node.Expanded());
                if (valueAccessor().NodeToggled != undefined) {
                    valueAccessor().NodeToggled(node);
                }
            };
            this.NodeClick = function (node) {
                var self = this;
                if (typeof valueAccessor().BeforeNodeChange === "function") {
                    var res = valueAccessor().BeforeNodeChange(node);
                    if (typeof res === "object" && typeof res.done === "function") {
                        res.done(function (changingAllowedByDeferred) {
                            if (changingAllowedByDeferred == true) {
                                self.ChangeNode(node);
                            }
                        });
                    }
                    else {
                        if (res == true) {
                            self.ChangeNode(node);
                        }
                    }
                }
                else {
                    self.ChangeNode(node);
                }
            };
            this.ChangeNode = function (node) {
                this.SelectedNode(node);
                if (valueAccessor().Click != undefined) {
                    valueAccessor().Click(node);
                }
            };
            this.Expanded = ko.observable(true);
            this.dragStart = function (ev, dd) { };
            this.dragEnd = function (ev, dd) { };
            this.dragHandler = function (ev, dd) { };
            this.dropHandler = function (ev, dd) { };
            this.dropStart = function (ev, dd) { };
            this.dropEnd = function (ev, dd) { };
            this.validateDrop = function (draggedElement, droppedElement) { };
        };
        var newContext = ko.utils.extend(new baoTreeVM(), valueAccessor());
        $(element).css("position", "relative");
        $(element).html(Bao.Templates.baoTree);
        ko.applyBindingsToDescendants(newContext, element);
        return {
            controlsDescendantBindings: true
        };
    }
};